import React, { useEffect, useState } from 'react';
import { auth, db } from '../../utils/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { readSettings, writeSettings } from '../../utils/settings';

export default function SettingsPrivacy() {
  const [tracking, setTracking] = useState(false);
  const [personalization, setPersonalization] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async () => {
      setLoading(true);
      const { settings } = await readSettings(auth, db);
      setTracking(!!settings.privacy?.tracking);
      setPersonalization(!!settings.privacy?.personalization);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  return (
    <div className="bg-background-light dark:bg-background-dark min-h-screen">
      <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 max-w-5xl">
        <h1 className="text-2xl font-bold mb-4 text-text-dark dark:text-text-light">Gizlilik Ayarları</h1>
        <div className="panel rounded-xl shadow p-6 space-y-4">
          <div className="flex items-center justify-between">
            <span>Analitik Takibi</span>
            <input
              type="checkbox"
              disabled={loading}
              checked={tracking}
              onChange={async (e)=>{
                const v = e.target.checked; setTracking(v);
                await writeSettings(auth, db, { privacy: { tracking: v, personalization } });
              }} />
          </div>
          <div className="flex items-center justify-between">
            <span>Kişiselleştirme</span>
            <input
              type="checkbox"
              disabled={loading}
              checked={personalization}
              onChange={async (e)=>{
                const v = e.target.checked; setPersonalization(v);
                await writeSettings(auth, db, { privacy: { tracking, personalization: v } });
              }} />
          </div>
        </div>
      </main>
    </div>
  );
}
